export const routes = [
  {
    path: '/',
    name: 'default',
    component: () => import('components/pages/home'),
    display: (roles) => roles.some(r => r === "Admin") ? "Admin" : "Home",
    meta: {
      showInMenu: true,
      icon: 'home',
      title: 'Home',
      layout: 'authorized',
    }
  },
  {
    path: '/401-forbidden',
    name: 'forbidden',
    component: () => import('components/pages/error/401-forbidden'),
    display: '401 Forbidden',
    meta: {
      title: '401 Forbidden'
    }
  },
  {
    path: '/two-factor-authentication',
    name: 'twofactorauthentication',
    component: () => import('components/pages/auth/two-factor-auth'),
    display: 'Two Factor Authentication',
    meta: {
      title: 'Two Factor Authentication'
    }
  },
  {
    path: '/404-not-found',
    name: 'not-found',
    component: () => import('components/pages/error/404-not-found'),
    display: '404 Page Not Found',
    meta: {
      title: '404 Page Not Found'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('components/pages/auth/login'),
    display: 'Login',
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/register',
    component: () => import('components/pages/auth/register'),
    display: 'Register',
    meta: {
      title: 'Register'
    }
  },
  {
    path: '/auth/forgot-password',
    component: () => import('components/pages/auth/forgot-password'),
    meta: {
      title: 'Forgot Password'
    }
  },
  {
    path: '/auth/reset-password',
    component: () => import('components/pages/auth/reset-password'),
    props: (route) => ({ code: route.query.code }),
    meta: {
      title: 'Reset Password'
    }
  },
  {
    path: '/auth/confirm-email',
    component: () => import('components/pages/auth/confirm-email'),
    props: (route) => ({ userId: route.query.userId, token: route.query.token }),
    meta: {
      title: 'Confirm Email'
    }
  },
  {
    path: '/auth/profile/create-profile',
    component: () => import('components/pages/auth/profile/create-profile'),
      props: (route) => ({ userId: route.query.userId, token: route.query.token, isPatient: route.query.isPatient }),
    meta: {
      title: 'Create Profile'
    }
  },
  {
    path: '/auth/admin/create-profile-step-1',
    component: () => import('components/pages/auth/admin/create-profile-step-1'),
    props: (route) => ({ userId: route.query.userId, token: route.query.token }),
    meta: {
      title: 'Create Profile'
    }
  },
  {
    path: '/auth/admin/create-profile-step-2',
    component: () => import('components/pages/auth/admin/create-profile-step-2'),
    props: (route) => ({ userId: route.query.userId, token: route.query.token, password: route.query.password }),
    meta: {
      title: 'Create Profile'
    }
  },
  {
    path: '/admin/user-list',
    component: () => import('components/pages/admin/users/user-list'),
    display: 'Users',
    meta: {
      showInMenu: true,
      icon: 'user',
      title: 'Users',
      layout: 'authorized',
      auth: { roles: ['Admin'] }
    }
  },
  {
    path: '/admin/clients',
    component: () => import('components/pages/admin/clients/clients-list'),
    display: 'Clients',
    meta: {
      showInMenu: true,
      icon: 'client',
      title: 'Clients',
      layout: 'authorized',
      auth: { roles: ['Admin', 'ClientAdmin'] }
    }
  },
  {
    path: '/admin/coupons',
    component: () => import('components/pages/coupons/coupons-list'),
    display: 'Coupons',
    meta: {
      showInMenu: true,
      icon: 'coupon',
      title: 'Coupons',
      layout: 'authorized',
      auth: { roles: ['Admin'] }
    }
  },
  {
    path: '/reports',
    component: () => import('components/pages/reports/reports-list'),
    display: 'Reports',
    meta: {
      showInMenu: true,
      icon: 'reports',
      title: 'Reports',
      layout: 'authorized',
      auth: { roles: ['Patient', 'Client', 'ClientUser', 'ClientOrderer', 'Admin', 'ClientProvider', 'ClientAdmin'] }
    }
  },
  {
    path: '/admin/provider-list',
    component: () => import('components/pages/admin/providers/provider-list'),
    display: 'Providers',
    meta: {
      showInMenu: true,
      icon: 'user',
      title: 'Providers',
      layout: 'authorized',
      auth: { roles: ['Admin'] }
    }
  },
  {
    path: '/reports/create',
    component: () => import('components/pages/reports/create-report'),
    display: 'Order Analysis',
    meta: {
      title: 'Order Analysis',
      layout: 'authorized',
      auth: { roles: ['Client', 'ClientUser', 'ClientOrderer', 'ClientProvider', 'Admin', 'ClientAdmin'] }
    }
  },
  {
    path: '/reports/:id/view',
    component: () => import('components/pages/reports/report-view/report'),
    display: 'Report',
    meta: {
      title: 'Report',
      layout: 'authorized',
      auth: { roles: ['Admin', 'Client', 'ClientUser', 'ClientOrderer', 'ClientProvider'] }
    }
  },
  {
    name: 'create/type',
    path: '/reports/create/type',
    component: () => import('components/pages/reports/create-report-type'),
    display: 'Order Analysis',
    meta: {
      title: 'Order Analysis',
      layout: 'authorized',
      auth: { roles: ['Client', 'ClientUser', 'ClientOrderer', 'ClientProvider', 'Admin', 'ClientAdmin'] }
    }
  },
  {
    path: '/reports/create/completed',
    component: () => import('components/pages/reports/create-report-completed'),
    display: 'Order Analysis',
    meta: {
      title: 'Order Analysis',
      layout: 'authorized',
      auth: { roles: ['Client', 'ClientUser', 'ClientOrderer', 'ClientProvider', 'Admin', 'ClientAdmin'] }
    }
  },
  {
    path: '/reports/create/patient',
    component: () => import('components/pages/reports/create-report-patient'),
    display: 'Order Analysis',
    meta: {
      title: 'Order Analysis',
      layout: 'authorized',
      auth: { roles: ['Client', 'ClientUser', 'ClientOrderer', 'ClientProvider', 'Admin', 'ClientAdmin'] }
    }
  },
  {
    path: '/employees',
    component: () => import('components/pages/employees/employees-list'),
    display: 'Team Members',
    meta: {
      showInMenu: true,
      icon: 'members',
      title: 'Team Members',
      layout: 'authorized',
      auth: { roles: ['Client', 'ClientProvider', 'ClientAdmin'] }
    }
  },
  {
    path: '/employees/create',
    component: () => import('components/pages/employees/create-employee'),
    display: 'Add Team Member',
    meta: {
      title: 'Add Team Member',
      layout: 'authorized',
      auth: { roles: ['Client', 'ClientProvider', 'ClientAdmin'] }
    }
  },
  {
    path: '/survey',
    component: () => import('components/pages/surveys/survey'),
    display: 'Survey',
    meta: {
      showInMenu: true,
      icon: 'survey',
      title: 'Survey',
      layout: 'authorized',
      auth: { roles: ['Patient'] }
    }
  },
  {
    path: '/survey-incompleted',
    component: () => import('components/pages/surveys/survey-incompleted'),
    display: 'Survey Incompleted',
    meta: {
      title: 'Survey Incompleted',
      layout: 'authorized',
      auth: { roles: ['Patient'] }
    }
  },
  {
    path: '/survey-completed',
    component: () => import('components/pages/surveys/survey-completed'),
    display: 'Survey Completed',
    meta: {
      title: 'Survey Completed',
      layout: 'authorized',
      auth: { roles: ['Patient'] }
    }
  },
  {
    path: '/profile/edit',
    component: () => import('components/pages/profile'),
    display: 'Edit profile',
    meta: {
      auth: true,
      layout: 'authorized',
      title: 'Edit Profile'
    }
  },
  {
    path: '/profile/api',
    component: () => import('components/pages/profile/api'),
    display: 'API Keys',
    meta: {
      layout: 'authorized',
      title: 'API Keys',
      auth: { roles: ['Admin', 'Client'] }
    }
  },
  {
    path: '/information/client-resources',
    component: () => import('components/pages/information/client-resources'),
    display: 'Client Resources',
    meta: {
      auth: true,
      layout: 'authorized',
      title: 'Client Resources'
    }
  },
  {
    path: '/information/video-content',
    component: () => import('components/pages/information/video-content'),
    display: 'Video Content',
    meta: {
      auth: true,
      layout: 'authorized',
      title: 'Video Content'
    }
  },
  {
    path: '/client-features',
    component: () => import('components/pages/admin/features'),
    display: 'Client Features',
    meta: {
      layout: 'authorized',
      title: 'Client Features',
      auth: { roles: ['Admin'] }
    }
  },
  {
    path: '/client-notifications',
    component: () => import('components/pages/admin/client-notifications'),
    display: 'Client Notifications',
    meta: {
      layout: 'authorized',
      title: 'Client Notifications',
      auth: { roles: ['Admin'] }
    }
  },
  {
    path: '/tags',
    component: () => import('components/pages/admin/tags'),
    display: 'Tags',
    meta: {
      showInMenu: true,
      layout: 'authorized',
      icon: "tag",
      title: 'Tags',
      auth: { roles: ['Admin', 'ClientAdmin'] }
    }
  },

  { path: '*', redirect: { name: 'not-found' } }
];

export default routes;